// Console loglarını tamamen devre dışı bırak
import './utils/consoleOverride';

// Firebase'i başlat
import './firebase/config';

// React ve diğer bağımlılıkları import et
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { tr } from 'date-fns/locale';
import '@mui/x-date-pickers/DatePicker/datePickerToolbarClasses';

// React uygulamasını başlat
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
      <App />
    </LocalizationProvider>
  </React.StrictMode>
);

// Performance ölçümlerini sessizce çalıştır
reportWebVitals(() => {});
